import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { currentSiteScopes } from '../selectors/ScopeSelector';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import SearchActions from '../actions/SearchActions';
import SearchScopeField from '../components/search/SearchScopeField';

const mapStateToProps = (state) => ({
  scopes: currentSiteScopes(state),
  currentSearchScope: state.getIn(['search', 'catalogSearch', 'scope']),
  scopeFacetEnabled: currentLibrarySelector(state).get('scopeFacetEnabled')
});

const mapDispatchToProps = (dispatch) => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

const SearchScopeFieldContainer = ({ scopes, currentSearchScope, scopeFacetEnabled }) => {
  if (!scopeFacetEnabled || typeof scopes === 'undefined' || scopes.size <= 1) {
    return null;
  }
  return <SearchScopeField scopes={scopes} currentSearchScope={currentSearchScope} />;
};


SearchScopeFieldContainer.propTypes = {
  scopes: PropTypes.arrayOf(
    PropTypes.shape({
      scopeName: PropTypes.string.isRequired,
      scopeId: PropTypes.string.isRequired,
      parentScopeId: PropTypes.string.isRequired
    }).isRequired
  ),
  scopeFacetEnabled: PropTypes.bool.isRequired,
  currentSearchScope: PropTypes.string.isRequired
};

SearchScopeFieldContainer.displayName = 'SearchScopFieldContainer';
export default connect(mapStateToProps, mapDispatchToProps)(SearchScopeFieldContainer);



// WEBPACK FOOTER //
// ./app/containers/SearchScopeFieldContainer.jsx